(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kaki-advertorial-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kaki-advertorial-sticky')) {
    class KakiAdvertorialSticky extends HTMLElement {
      /** @type {AbortController | undefined} */
      #controller;
      /** @type {number} */
      #frame = 0;

      connectedCallback() {
        this.#controller?.abort();
        this.#controller = new AbortController();
        const { signal } = this.#controller;
        window.addEventListener('scroll', this.#schedule, { passive: true, signal });
        window.addEventListener('resize', this.#schedule, { passive: true, signal });
        this.#update();
      }

      disconnectedCallback() {
        this.#controller?.abort();
        if (this.#frame) cancelAnimationFrame(this.#frame);
        this.#frame = 0;
      }

      #schedule = () => {
        if (this.#frame) return;
        this.#frame = requestAnimationFrame(() => {
          this.#frame = 0;
          this.#update();
        });
      };

      #update() {
        const offset = Number(this.dataset.offset) || 0;
        const offer = document.getElementById('kaki-offre');
        let offerReached = false;
        if (offer instanceof HTMLElement) {
          offerReached = offer.getBoundingClientRect().top < window.innerHeight;
        }
        const visible = window.scrollY > offset && !offerReached;
        this.toggleAttribute('data-visible', visible);
        this.toggleAttribute('inert', !visible);
      }
    }

    customElements.define('kaki-advertorial-sticky', KakiAdvertorialSticky);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaki-home-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kaki-quick-add')) {
    /**
     * Ajout direct au panier depuis la grille d'accueil.
     * Reprend le contrat d'Horizon (CartLinesUpdateEvent + sections du tiroir) pour que
     * le tiroir panier et le compteur se mettent à jour. Sans JS, le formulaire poste vers /cart/add.
     */
    class KakiQuickAdd extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.status = this.querySelector('[data-kaki-status]');
        this.onSubmit = this.onSubmit.bind(this);
        if (this.form) this.form.addEventListener('submit', this.onSubmit);
      }

      disconnectedCallback() {
        if (this.form) this.form.removeEventListener('submit', this.onSubmit);
      }

      async onSubmit(event) {
        if (!window.Theme || !window.Theme.routes) return;
        event.preventDefault();
        if (this.classList.contains('is-loading')) return;

        let events;
        try {
          events = await import('@shopify/events');
        } catch (error) {
          this.form.submit();
          return;
        }

        const { CartLinesUpdateEvent } = events;
        const routes = window.Theme.routes;
        const formData = new FormData(this.form);
        const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
          .map((el) => el.dataset.sectionId)
          .filter(Boolean);
        if (sectionIds.length) formData.append('sections', sectionIds.join(','));

        this.classList.add('is-loading');
        this.setStatus('');

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: String(formData.get('id')), quantity: 1 }],
            promise: deferred.promise,
          })
        );

        try {
          const response = await fetch(routes.cart_add_url, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
            body: formData,
          });
          const data = await response.json();
          const cart = await fetch(`${routes.cart_url}.json`, {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin',
          }).then((r) => r.json());

          const didError = Boolean(data.status);
          deferred.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: {
              didError,
              items: cart.items,
              source: 'kaki-quick-add',
              itemCount: 1,
              sections: didError ? undefined : data.sections,
            },
          });

          if (didError) {
            this.setStatus(data.description || data.message || '');
          } else {
            this.classList.add('is-added');
            window.setTimeout(() => this.classList.remove('is-added'), 2500);
          }
        } catch (error) {
          deferred.reject(error);
          this.form.submit();
        } finally {
          this.classList.remove('is-loading');
        }
      }

      setStatus(message) {
        if (this.status) this.status.textContent = message;
      }
    }

    customElements.define('kaki-quick-add', KakiQuickAdd);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaki-image-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kaki-scroll-to-buy')) {
    class KakiScrollToBuy extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.addEventListener('click', (event) => this.handleClick(event), { signal: this.abort.signal });
      }

      disconnectedCallback() {
        this.abort?.abort();
      }

      /** @param {MouseEvent} event */
      handleClick(event) {
        if (!(event.target instanceof Element) || !event.target.closest('a')) return;
        const target =
          document.getElementById('kaki-commander') || document.querySelector('form[data-type="add-to-cart-form"]');
        if (!target) return;
        event.preventDefault();
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      }
    }
    customElements.define('kaki-scroll-to-buy', KakiScrollToBuy);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaki-listicle-buybox"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kaki-listicle-buy-form')) {
    class KakiListicleBuyForm extends HTMLElement {
      connectedCallback() {
        this.price = this.querySelector('[data-price]');
        this.compare = this.querySelector('[data-compare]');
        this.submit = this.querySelector('button[type="submit"]');
        this.qty = this.querySelector('input[name="quantity"][type="number"]');

        this.addEventListener('change', (event) => {
          if (event.target.matches('input[type="radio"][name="id"]')) this.onVariant(event.target);
        });
        this.addEventListener('click', (event) => {
          const step = event.target.closest('[data-qty-step]');
          if (!step || !this.qty) return;
          const next = (parseInt(this.qty.value, 10) || 1) + parseInt(step.dataset.qtyStep, 10);
          this.qty.value = Math.min(99, Math.max(1, next));
        });
      }

      onVariant(input) {
        if (this.price) this.price.textContent = input.dataset.price;
        if (this.compare) {
          if (input.dataset.compare) {
            this.compare.textContent = input.dataset.compare;
            this.compare.hidden = false;
          } else {
            this.compare.hidden = true;
          }
        }
        if (this.submit) {
          this.submit.disabled = false;
          this.submit.textContent = this.submit.dataset.label;
        }
      }
    }
    customElements.define('kaki-listicle-buy-form', KakiListicleBuyForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaki-listicle-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kaki-sticky-cta')) {
    class KakiStickyCta extends HTMLElement {
      connectedCallback() {
        this.pastHero = false;
        this.offerVisible = false;
        const hero = document.querySelector('[data-kaki-listicle-hero]');
        const offer = document.querySelector('[data-kaki-listicle-buybox]');

        if (!('IntersectionObserver' in window)) {
          this.hidden = false;
          return;
        }

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === hero) {
              this.pastHero = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            }
            if (entry.target === offer) {
              this.offerVisible = entry.isIntersecting;
            }
          });
          this.update();
        });

        if (hero) {
          this.observer.observe(hero);
        } else {
          this.pastHero = true;
        }
        if (offer) this.observer.observe(offer);
        this.update();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      update() {
        const show = this.pastHero && !this.offerVisible;
        this.hidden = false;
        this.classList.toggle('is-visible', show);
        this.toggleAttribute('inert', !show);
      }
    }
    customElements.define('kaki-sticky-cta', KakiStickyCta);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaki-promo-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kaki-promo-popup')) {
    class KakiPromoPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.cards = Array.from(this.querySelectorAll('[data-kaki-card]'));
        this.result = this.querySelector('[data-kaki-result]');
        this.live = this.querySelector('[data-kaki-live]');
        this.copyButton = this.querySelector('[data-kaki-copy]');
        this.signup = this.querySelector('[data-kaki-signup]');
        this.form = this.signup ? this.signup.querySelector('form') : null;
        this.emailInput = this.querySelector('[data-kaki-email]');
        this.submitButton = this.querySelector('[data-kaki-submit]');
        this.timers = [];

        this.handleClick = this.handleClick.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleExit = this.handleExit.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleDeselect = this.handleDeselect.bind(this);

        this.handleSubmit = this.handleSubmit.bind(this);

        this.dialog.addEventListener('click', this.handleClick);
        this.dialog.addEventListener('close', this.handleClose);
        if (this.form) this.form.addEventListener('submit', this.handleSubmit);

        if (this.hasAttribute('data-design-mode')) {
          document.addEventListener('shopify:section:select', this.handleSelect);
          document.addEventListener('shopify:section:deselect', this.handleDeselect);
          return;
        }

        // Retour après une inscription envoyée sans JavaScript (ou après la vérification anti-robot de Shopify) :
        // on rouvre la pop-up directement sur le code.
        if (this.storage('session', 'get', 'kaki-popup-pending') === '1' && window.location.search.includes('customer_posted=true')) {
          this.storage('session', 'remove', 'kaki-popup-pending');
          this.storage('local', 'set', 'kaki-popup-subscribed', '1');
          this.markSeen();
          this.open();
          this.revealed = true;
          this.cards.forEach((item) => (item.disabled = true));
          this.showResult();
          return;
        }

        if (this.alreadySeen()) return;

        // Mémorise chaque clic sur un bouton d'ajout au panier (Moon, thème…) pour ne pas ouvrir la pop-up pendant que le panier s'ouvre.
        document.addEventListener('click', (event) => {
          const btn = event.target.closest('button, [type="submit"], a');
          if (btn && /ajouter au panier|add to cart/i.test(btn.textContent || btn.value || '')) window.__kasuriAtcAt = Date.now();
        }, true);

        const delay = Number(this.dataset.delay) || 0;
        const scroll = Number(this.dataset.scroll) || 0;
        if (delay > 0) this.timers.push(window.setTimeout(() => this.trigger(), delay * 1000));
        if (scroll > 0) window.addEventListener('scroll', this.handleScroll, { passive: true });
        if (this.dataset.exit === 'true' && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          document.documentElement.addEventListener('mouseleave', this.handleExit);
        }
        if (delay <= 0 && scroll <= 0 && this.dataset.exit !== 'true') this.trigger();
      }

      disconnectedCallback() {
        this.cleanupTriggers();
        document.removeEventListener('shopify:section:select', this.handleSelect);
        document.removeEventListener('shopify:section:deselect', this.handleDeselect);
        document.documentElement.classList.remove('kaki-popup-lock');
      }

      storage(kind, action, key, value) {
        try {
          const store = kind === 'local' ? window.localStorage : window.sessionStorage;
          if (action === 'get') return store.getItem(key);
          if (action === 'set') store.setItem(key, value);
          if (action === 'remove') store.removeItem(key);
        } catch (error) {
          /* stockage indisponible (navigation privée) : on ignore */
        }
        return null;
      }

      alreadySeen() {
        // Déjà inscrite : on ne remontre jamais la pop-up.
        if (this.storage('local', 'get', 'kaki-popup-subscribed') === '1') return true;
        return this.storage('session', 'get', this.dataset.key) === '1';
      }

      markSeen() {
        this.storage('session', 'set', this.dataset.key, '1');
      }

      cleanupTriggers() {
        this.timers.forEach((id) => window.clearTimeout(id));
        this.timers = [];
        window.removeEventListener('scroll', this.handleScroll);
        document.documentElement.removeEventListener('mouseleave', this.handleExit);
      }

      handleScroll() {
        if (this.scrollTicking) return;
        this.scrollTicking = true;
        window.requestAnimationFrame(() => {
          this.scrollTicking = false;
          const doc = document.documentElement;
          const max = doc.scrollHeight - window.innerHeight;
          if (max <= 0) return;
          const percent = (window.scrollY / max) * 100;
          if (percent >= Number(this.dataset.scroll)) this.trigger();
        });
      }

      handleExit(event) {
        if (event.clientY <= 0) this.trigger();
      }

      trigger() {
        if (this.dialog.open) return;
        // Pop-up masqué par la page (ex. page 7 raisons) : ne jamais ouvrir une fenêtre invisible qui bloquerait la page.
        if (window.getComputedStyle(this).display === 'none' || (this.closest('.shopify-section') && window.getComputedStyle(this.closest('.shopify-section')).display === 'none')) {
          this.cleanupTriggers();
          return;
        }
        // Clic récent sur « Ajouter au panier » : le tiroir est en train de s'ouvrir, on attend.
        if (window.__kasuriAtcAt && Date.now() - window.__kasuriAtcAt < 8000) {
          this.timers.push(window.setTimeout(() => this.trigger(), 4000));
          return;
        }
        // Tiroir panier (OCU) ou autre fenêtre ouverte : on ne l'interrompt pas, on réessaie une fois qu'il est fermé.
        // Panier fermé mais avec des articles : on affiche quand même (le code peut la pousser à finir son achat).
        if (document.querySelector('dialog[open], .ocu-cart-drawer.ocu-visible')) {
          this.timers.push(window.setTimeout(() => this.trigger(), 4000));
          return;
        }
        this.cleanupTriggers();
        this.markSeen();
        this.open();
      }

      open() {
        if (this.dialog.open) return;
        this.dialog.showModal();
        document.documentElement.classList.add('kaki-popup-lock');
      }

      close() {
        if (this.dialog.open) this.dialog.close();
      }

      handleClose() {
        document.documentElement.classList.remove('kaki-popup-lock');
      }

      handleSelect(event) {
        if (event.detail && event.detail.sectionId === this.dataset.sectionId) this.open();
      }

      handleDeselect(event) {
        if (event.detail && event.detail.sectionId === this.dataset.sectionId) this.close();
      }

      handleClick(event) {
        const target = event.target;
        if (target === this.dialog) {
          this.close();
          return;
        }
        if (!(target instanceof Element)) return;
        if (target.closest('[data-kaki-close]')) {
          this.close();
          return;
        }
        const card = target.closest('[data-kaki-card]');
        if (card) {
          this.reveal(card);
          return;
        }
        if (target.closest('[data-kaki-copy]')) this.copy();
      }

      message(name) {
        const template = this.querySelector('template[data-kaki-messages]');
        const node = template && template.content.querySelector(`[data-${name}]`);
        return node ? node.textContent.trim() : '';
      }

      reveal(card) {
        if (this.revealed) return;
        this.revealed = true;
        this.cards.forEach((item) => {
          item.disabled = item !== card;
          if (item === card) {
            item.classList.add('is-flipped');
            item.setAttribute('aria-disabled', 'true');
          } else {
            item.classList.add('is-other');
          }
        });
        const delay = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 650;
        window.setTimeout(() => {
          if (this.dataset.requireEmail === 'true' && this.signup) {
            this.signup.hidden = false;
            if (this.emailInput) this.emailInput.focus();
          } else {
            this.showResult();
          }
        }, delay);
      }

      showResult() {
        if (this.signup) this.signup.hidden = true;
        if (this.result) this.result.hidden = false;
        if (this.live) this.live.textContent = this.message('revealed');
        if (this.copyButton) this.copyButton.focus();
      }

      async handleSubmit(event) {
        event.preventDefault();
        const form = this.form;
        if (!form || this.submitting) return;
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }
        this.submitting = true;
        if (this.submitButton) this.submitButton.disabled = true;
        // Si Shopify demande une vérification anti-robot, la page est rechargée : ce drapeau permet de rouvrir sur le code.
        this.storage('session', 'set', 'kaki-popup-pending', '1');
        try {
          const response = await fetch(form.action, {
            method: 'POST',
            body: new FormData(form),
            headers: { Accept: 'text/html' },
          });
          if (response.url && response.url.includes('/challenge')) {
            form.submit();
            return;
          }
        } catch (error) {
          /* réseau indisponible : on ne bloque pas la cliente, le code est révélé quand même */
        }
        this.storage('session', 'remove', 'kaki-popup-pending');
        this.storage('local', 'set', 'kaki-popup-subscribed', '1');
        this.submitting = false;
        this.showResult();
      }

      async copy() {
        const codeEl = this.querySelector('[data-kaki-code]');
        const code = codeEl ? codeEl.textContent.trim() : '';
        if (!code) return;
        try {
          await navigator.clipboard.writeText(code);
        } catch (error) {
          const range = document.createRange();
          range.selectNodeContents(codeEl);
          const selection = window.getSelection();
          if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
          }
          try {
            document.execCommand('copy');
          } catch (ignored) {
            /* la sélection reste visible : la cliente peut copier à la main */
          }
        }
        const copied = this.message('copied');
        if (this.copyButton && copied) this.copyButton.textContent = copied;
        if (this.live && copied) this.live.textContent = copied;
      }
    }

    customElements.define('kaki-promo-popup', KakiPromoPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaki-scroll-top"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kaki-scroll-top')) {
    class KakiScrollTop extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.onScroll = this.onScroll.bind(this);
        this.onClick = this.onClick.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        if (this.button) this.button.addEventListener('click', this.onClick);
        this.onScroll();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        if (this.button) this.button.removeEventListener('click', this.onClick);
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        window.requestAnimationFrame(() => {
          this.ticking = false;
          const threshold = Number(this.dataset.threshold) || 600;
          this.classList.toggle('is-visible', window.scrollY > threshold);
        });
      }

      onClick() {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
        const target = document.querySelector('#MainContent') || document.body;
        if (target instanceof HTMLElement) {
          if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
        }
      }
    }

    customElements.define('kaki-scroll-top', KakiScrollTop);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaki-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kaki-sticky-atc')) {
    class KakiStickyAtc extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.button = this.querySelector('[data-kaki-sticky-button]');
        this.button?.addEventListener('click', () => this.handleClick(), { signal: this.abort.signal });
        this.setVisible(false);
        this.observe();
        this.watchPack();
      }

      /* Kasuri 22/10 : la barre affiche le pack choisi dans Moon (sinon elle montrait toujours le prix d'un seul savon) */
      watchPack() {
        this.priceEl = this.querySelector('.kaki-sticky__price');
        if (this.priceEl) this.priceEl.style.whiteSpace = 'nowrap';
        let scheduled = false;
        const run = () => {
          scheduled = false;
          const target = this.getMainButton() || this.getForm();
          if (target && target !== this.observedTarget) {
            this.observer?.disconnect();
            this.observe();
          }
          this.syncPack();
        };
        this.packObserver = new MutationObserver(() => {
          if (scheduled) return;
          scheduled = true;
          requestAnimationFrame(run);
        });
        this.packObserver.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
        this.syncPack();
      }

      syncPack() {
        const active = document.querySelector('.moonbundle-box .moonbundle-option-active');
        if (!active || !this.priceEl) return;
        const title = active.querySelector('.moonbundle-option-title')?.textContent.trim();
        const total = active.querySelector('.moonbundle-option-each-price')?.textContent.trim();
        const old = active.querySelector('.moonbundle-option-old-price')?.textContent.trim();
        if (!total) return;
        const key = [title, total, old].join('|');
        if (key === this.lastPackKey) return;
        this.lastPackKey = key;
        this.priceEl.replaceChildren();
        const titleEl = this.querySelector('.kaki-sticky__title');
        if (title && titleEl) titleEl.textContent = title;
        if (old && old !== total) {
          const compare = document.createElement('s');
          compare.className = 'kaki-sticky__compare';
          compare.textContent = old;
          this.priceEl.append(compare);
        }
        const price = document.createElement('span');
        price.textContent = total;
        this.priceEl.append(price);
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.packObserver?.disconnect();
      }

      /** @returns {HTMLFormElement | null} */
      getForm() {
        return document.querySelector('form[data-type="add-to-cart-form"]');
      }

      /** @returns {HTMLButtonElement | null} */
      getMainButton() {
        const form = this.getForm();
        return form ? form.querySelector('button[name="add"], [type="submit"]') : null;
      }

      observe() {
        const target = this.getMainButton() || this.getForm();
        if (!target || !('IntersectionObserver' in window)) return;
        this.observedTarget = target;
        this.observer = new IntersectionObserver(([entry]) => {
          if (!entry) return;
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.setVisible(scrolledPast);
        });
        this.observer.observe(target);
      }

      /** @param {boolean} visible */
      setVisible(visible) {
        this.dataset.visible = String(visible);
        this.toggleAttribute('inert', !visible);
        this.setAttribute('aria-hidden', String(!visible));
      }

      handleClick() {
        const mainButton = this.getMainButton();
        const anchor = document.getElementById('kaki-commander') || this.getForm();
        if (mainButton && !mainButton.disabled && !mainButton.hasAttribute('aria-disabled')) {
          mainButton.click();
          return;
        }
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        anchor?.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      }
    }
    customElements.define('kaki-sticky-atc', KakiStickyAtc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
